import { ProductRepository } from "../../../../data/repository/product/ProductRepository";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetDeliveryPriceUseCase {
  invoke: () => Promise<ResponseState<number>>;
}

export class GetDeliveryPriceUseCaseImpl implements GetDeliveryPriceUseCase {
  private repo: ProductRepository;

  constructor(repo: ProductRepository) {
    this.repo = repo;
  }

  async invoke(): Promise<ResponseState<number>> {
    try {
      let response = await this.repo.getDeliveryPrice();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
